import { createSelector } from 'reselect'

const selectOfflineState = state => state.offline

export const selectIsOnline = createSelector(
  selectOfflineState,
  offline => offline.isOnline
)

export const selectSyncQueueCount = createSelector(
  selectOfflineState,
  offline => offline.syncQueueCount
)

export const selectPendingFileCount = createSelector(
  selectOfflineState,
  offline => offline.pendingFileCount
)

export const selectPendingFileSizeMb = createSelector(
  selectOfflineState,
  offline => offline.pendingFileSizeMb
)

export const selectIsSyncing = createSelector(
  selectOfflineState,
  offline => offline.isSyncing
)

export const selectSyncProgress = createSelector(
  selectOfflineState,
  offline => offline.syncProgress
)

export const selectLastSyncedAt = createSelector(
  selectOfflineState,
  offline => offline.lastSyncedAt
)

export const selectSyncErrors = createSelector(
  selectOfflineState,
  offline => offline.syncErrors
)
